import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/whatsapp";

const FirstVisitPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasVisited = localStorage.getItem("hasVisited");
    if (!hasVisited) {
      setIsOpen(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem("hasVisited", "true");
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-[400px] sm:max-w-md mx-auto">
        <DialogHeader>
          <DialogTitle className="text-xl sm:text-2xl font-bold text-center px-2">
            Bem-vindo à EW Controle de Pragas!
          </DialogTitle>
          <DialogDescription className="text-center pt-3 sm:pt-4 text-sm sm:text-base px-2">
            Precisa de ajuda com controle de pragas? Entre em contato conosco pelo WhatsApp e solicite um orçamento gratuito!
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 sm:gap-4 pt-3 sm:pt-4">
          <Button
            asChild
            className="w-full touch-manipulation"
            size="lg"
            onClick={() => {
              localStorage.setItem("hasVisited", "true");
              setIsOpen(false);
            }}
          >
            <a 
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Phone className="w-5 h-5 mr-2" />
              Falar no WhatsApp
            </a>
          </Button>
          <Button
            variant="outline"
            onClick={handleClose}
            className="w-full touch-manipulation"
            size="lg"
          >
            Continuar navegando
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FirstVisitPopup;
